import actionTypes from '../constants/action-types';

const setDeviceMode = (deviceMode) => ({
  type: actionTypes.SET_DEVICE_MODE,
  payload: {
    deviceMode,
  },
});

export default setDeviceMode;
